import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  ECommissionEvaluationStatus,
  ICommissionEvaluation,
  ICommissionEvaluations,
} from 'types/commission-evaluation/commission-evaluation'
import { IPaginationQueryInfo } from 'types/pagination'

type ICMDPaginationQueryInfo = IPaginationQueryInfo & {
  status: ECommissionEvaluationStatus
}

type CommissionEvaluationAction = {
  tenderId: string
  decisionNote: string
}

export const commissionEvaluationApi = createApi({
  reducerPath: 'commissionEvaluation',
  baseQuery,
  tagTypes: ['CommissionEvaluation'],
  endpoints: (builder) => ({
    commissionEvaluationOverview: builder.query<
      ICommissionEvaluations,
      ICMDPaginationQueryInfo
    >({
      query: (params) => {
        return {
          url: '/commission-evaluation/overview',
          method: 'get',
          params,
        }
      },
      providesTags: ['CommissionEvaluation'],
    }),
    acceptCommissionEvaluation: builder.mutation<
      ICommissionEvaluation,
      Partial<CommissionEvaluationAction>
    >({
      query: (body) => ({
        url: `/commission-evaluation/accept`,
        body,
        method: 'post',
      }),
    }),
    rejectCommissionEvaluation: builder.mutation<
      ICommissionEvaluation,
      Partial<CommissionEvaluationAction>
    >({
      query: (body) => ({
        url: `/commission-evaluation/reject`,
        body,
        method: 'post',
      }),
    }),
  }),
})

export const {
  useCommissionEvaluationOverviewQuery,
  useAcceptCommissionEvaluationMutation,
  useRejectCommissionEvaluationMutation,
} = commissionEvaluationApi
